<template>
    <div
        class="d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed bg-global"
    >
        <!--begin::Content-->
        <div class="d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20">
            <!--begin::Logo-->
            <img alt="Logo" src="/media/logos/keyapp.logo.svg" class="h-40px  mb-15"/>
            <!--end::Logo-->

            <router-view></router-view>
        </div>
        <!--end::Content-->

        <!--begin::Footer-->
        <div class="d-flex flex-center flex-column-auto p-10">
        <span class="text-gray-400 fw-bold text-center fs-6">
            2015-{{ moment().year() }} © Keyapp.top.
            <router-link :to="{ name: 'terms-basic' }" class="fw-bold text-center fs-6 text-hover-primary svg-fill-ios">
              Terms and Conditions
            </router-link>
            and
            <router-link :to="{ name: 'privacy-policy-basic' }"
                         class="fw-bold text-center fs-6 text-hover-primary svg-fill-ios">
              Privacy Policy
            </router-link>
            Build: <span class="fw-bold text-center fs-6 text-black-50">{{ version }}</span>
        </span>
        </div>
        <!--end::Footer-->
    </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, onUnmounted, ref } from 'vue';
import { useStore } from 'vuex';
import { getIllustrationsPath } from '@/core/helpers/assets';
import moment from 'moment';
import StoreDispatcherService from '@/store/services/StoreDispatcherService';
import GeneralDispatcherService from '@/store/services/GeneralDispatcherService';

export default defineComponent({
  name: 'auth-page-layout',
  components: {},
  setup() {
    const store = useStore();
    const StoreDispatcher = new StoreDispatcherService(store);
    const GeneralDispatcher = new GeneralDispatcherService(store);
    const version = ref('');

    onMounted(async () => {
      StoreDispatcher.addBodyClassname('bg-body');
      await StoreDispatcher.version();
      version.value = GeneralDispatcher.getValidatedVersion();
    });

    onUnmounted(() => {
      StoreDispatcher.removeBodyClassname('bg-body');
    });

    return {
      version,
      moment,
      getIllustrationsPath
    };
  }
});
</script>
